import React, { useState } from 'react';
import { Box, TextField, Alert, Snackbar } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Send } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { submitContactForm } from '../../../services/api';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phoneNumber: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim() || !formData.phoneNumber.trim() || !formData.message.trim()) {
      setSnackbar({
        open: true,
        message: 'Please fill in all fields',
        severity: 'error',
      });
      return;
    }

    setLoading(true);

    const result = await submitContactForm(formData);

    if (result.success) {
      setSnackbar({
        open: true,
        message: 'Message sent successfully! We will get back to you soon.',
        severity: 'success',
      });
      setFormData({ name: '', phoneNumber: '', message: '' });
    } else {
      setSnackbar({
        open: true,
        message: result.error,
        severity: 'error',
      });
    }

    setLoading(false);
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2.5,
        }}
      >
        <TextField
          name="name"
          label="Full Name"
          value={formData.name}
          onChange={handleChange}
          required
          fullWidth
          variant="outlined"
          placeholder="Enter your full name"
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'rgba(248, 249, 252, 0.5)',
            },
          }}
        />

        <TextField
          name="phoneNumber"
          label="Phone Number"
          value={formData.phoneNumber}
          onChange={handleChange}
          required
          fullWidth
          variant="outlined"
          placeholder="+254 7XX XXX XXX"
          type="tel"
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'rgba(248, 249, 252, 0.5)',
            },
          }}
        />

        <TextField
          name="message"
          label="Your Message"
          value={formData.message}
          onChange={handleChange}
          required
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          placeholder="How can we help you?"
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'rgba(248, 249, 252, 0.5)',
            },
          }}
        />

        <LoadingButton
          component={motion.button}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          type="submit"
          variant="contained"
          color="primary"
          size="large"
          loading={loading}
          loadingPosition="end"
          endIcon={<Send />}
          sx={{
            mt: 1,
            py: 1.5,
          }}
        >
          Send Message
        </LoadingButton>
      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ContactForm;
